export default __webpack_public_path__ + "static/media/img2.7c11a9e5.png";